/*
 * Marks the body while the store-owner password dialog is open, so the hero
 * behind it can be hidden.
 *
 * Every hero element is position:fixed and forms its own stacking context,
 * so raising the dialog's z-index does not put it on top — the wordmark,
 * copy, form and links show through. The stylesheet also handles this with
 * :has(), which is unreliable on the older iOS Safari versions this page has
 * to work on; this class is the dependable path.
 */
(function () {
  var details = document.querySelector('.akari-entry details');
  if (!details) return;

  function sync() {
    document.body.classList.toggle('akari-modal-open', details.open);
  }

  details.addEventListener('toggle', sync);
  sync();
})();
